module.exports = __webpack_public_path__ + "media/images/vk-white-icon-3258da017898d9658d769180e2b8e649.png";